import { Button, Container, Drawer, Flex, useMantineTheme, Text, ThemeIcon } from "@mantine/core";
import { IconArrowRight } from "@tabler/icons-react";
import { ReactNode, useState } from "react";
import { i18n } from "../i18n/langType";
import { FormattedMessage } from "react-intl";
import { useMediaQuery } from '@mantine/hooks';
import { TariffDetailNode } from "../types/types";
import { InterimBlockingFeeDisplay } from "./interimBlockingFeeDisplay";

export const Feature = ({
  icon,
  hasDrawer,
  children,
  noBorder,
  hasArrow,
  nameI18n,
  descriptionI18n,
  valueI18n,
  showInlinePrice, // Add this new prop
  tariffNode,      // Add this new prop
  currency,        // Add this new prop
}: {
  hasArrow?: boolean;
  noBorder?: boolean;
  icon: JSX.Element;
  hasDrawer?: boolean;
  children?: ReactNode;
  nameI18n: string;
  descriptionI18n: string;
  valueI18n: string;
  showInlinePrice?: boolean;    // New prop
  tariffNode?: TariffDetailNode; // New prop
  currency?: string;            // New prop
}) => {
  const [opened, setOpened] = useState(false);
  const theme = useMantineTheme();
  
  const isMobile = useMediaQuery('(max-width: 768px)');
  const isSmallMobile = useMediaQuery('(max-width: 480px)');

  
  const getDrawerSize = () => {
    if (isSmallMobile) return "60%";
    if (isMobile) return "50%";
    return "xl";     
  };  return (
    <Flex
      style={
        hasDrawer && !showInlinePrice
          ? {
              textWrap: "nowrap",
              cursor: "pointer",
            }
          : {
              textWrap: "nowrap",
            }
      }
      gap="none"
      direction="column"
      pr="sm"
      align={"center"}
    >
      <ThemeIcon 
        onClick={() => hasDrawer && !showInlinePrice && setOpened(true)} 
        size="lg" 
        color={"none"}
      >
        {icon}
      </ThemeIcon>
      <Text 
        onClick={() => hasDrawer && !showInlinePrice && setOpened(true)} 
        color={theme.colors.gray[4]} 
        size="sm" 
        fw="light"
      >
        {nameI18n}
      </Text>
      
      {showInlinePrice && tariffNode && currency ? (
        <InterimBlockingFeeDisplay tariffNode={tariffNode} currency={currency} />
      ) : (
        <Text
          onClick={() => hasDrawer && !showInlinePrice && setOpened(true)}
          size="xl"
          fw="600"
        >
          {valueI18n}
        </Text>
      )}
      
      <Flex justify="center">
        <Text
          style={hasArrow ? { marginRight: "2px" } : {}}
          onClick={() => hasDrawer && !showInlinePrice && setOpened(true)}
          color={theme.colors.gray[4]}
          size="sm"
          fw="light"
        >
          {descriptionI18n}
        </Text>{" "}
        {hasArrow && !showInlinePrice ? <IconArrowRight color={theme.colors.gray[4]} size="14" /> : null}
      </Flex>
      
      {hasDrawer && !showInlinePrice && (
       <Drawer
          transitionProps={{
            transition: "slide-up",
            duration: 500,
            timingFunction: "ease",
          }}
          position="bottom"
          opened={opened}
          onClose={() => setOpened(false)}
          padding="sm"
          size={getDrawerSize()}
          withCloseButton={false}
          h="100%"
          radius="lg"
        >
          <Container size="lg" pos="relative" h="100%" display="flex" style={{ flexDirection: "column" }}>
            <Container
              bg={theme.colors.gray[0]}
              h="3px"
              w="xl"
              pos="absolute"
              mx="auto"
              top="5px"
              left="50%"
              style={{ transform: "translate(-50%, -50%)" }}
            />
            {children}
            <Flex pt="md" mt="auto" direction="column" align="flex-end" justify="flex-end">
              <Button
                onClick={() => setOpened(false)}
                color="dark"
                style={{ fontWeight: 500 }}
                radius="xl"
                size="md"
                tt="uppercase"
                mb="sm"
              >
                <FormattedMessage id={i18n.close} />
              </Button>
            </Flex>
          </Container>
        </Drawer>
      )}
    </Flex>
  );
};
